import { ROLE_ADMIN, ROLE_RESTAURANT } from '@/enum/roles'
import routeType from '@/router/routeType'

const meta = {
    requiresAuth: true,
    roles: [ROLE_ADMIN, ROLE_RESTAURANT],
    layout: 'ordit-authenticated-layout',
}

const breadCrumbs = {
    list: {
        to: {
            name: routeType.RESTAURANT_LIST,
        },
        text: 'menu.restaurants',
    },
    edit: {
        to: {
            name: routeType.RESTAURANT_EDIT,
        },
        label: '...',
    },
}

export default [
    {
        path: '/restaurants',
        component: {
            render: (c) => c('router-view'),
        },
        meta: {
            ...meta,
            breadcrumb: breadCrumbs.list,
        },
        children: [
            {
                path: '',
                name: routeType.RESTAURANT_LIST,
                component: () =>
                    import(
                        /* webpackChunkName: "restaurant-list" */ '@/pages/restaurants/List'
                    ),
                meta: {
                    ...meta,
                    roles: [ROLE_ADMIN],
                },
            },
            {
                path: 'create',
                name: routeType.RESTAURANT_CREATE,
                component: () =>
                    import(
                        /* webpackChunkName: "restaurant-edit" */ '@/pages/restaurants/Create'
                    ),
                meta: {
                    ...meta,
                    roles: [ROLE_ADMIN],
                    breadcrumb: breadCrumbs.edit,
                },
            },
            {
                path: ':id/:page?',
                name: routeType.RESTAURANT_EDIT,
                component: () =>
                    import(
                        /* webpackChunkName: "restaurant-edit" */ '@/pages/restaurants/Edit'
                    ),
                meta: {
                    ...meta,
                    breadcrumb: breadCrumbs.edit,
                },
            },
        ],
    },
]
